import { render, staticRenderFns } from "./PercentageCalculator.vue?vue&type=template&id=a6c7fb08&scoped=true&"
import script from "./PercentageCalculator.vue?vue&type=script&lang=js&"
export * from "./PercentageCalculator.vue?vue&type=script&lang=js&"
import style0 from "./PercentageCalculator.vue?vue&type=style&index=0&id=a6c7fb08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c7fb08",
  null
  
)

export default component.exports